export const PartnerType = {
  INDIVIDUAL: 'Individual',
  EDUCATION_AGENT: 'Education agent',
  UNIVERSITY_INCLUDING_FEEDER: 'University (including feeder)',
  STUDENT_ASSOCIATION: 'Student association',
  ONLINE: 'Online',
  OTHER: 'Other',
  MARKETING_MEDIA_PARTNER: 'Marketing Media Partner',
  GLOBAL_EDUCATION_PARTNER: 'Global Education partner',
  THIRD_PARTY_PARTNER_EASY_TRANSFER_USA: 'Third Party Partner (Easy Transfer USA)',
  UNIVERSITY_STUDENT_AMBASSADOR: 'University (Student Ambassador)',
  EDUCATION_PARTNER: 'Education partner',
  THIRD_PARTY_PARTNER_HOOLI_HOME: 'Third Party Partner (Hooli Home)',
  THIRD_PARTY_EDUCATION_RELATED_SERVICE_PROVIDER:
    'Third Party (Education related service provider)',
  THIRD_PARTY_PARTNER_STUDAPART: 'Third Party Partner (Studapart)',
  CHAT_GROUP: 'Chat Group',
  SOCIAL: 'Social',
  THIRD_PARTY_COMMERCIAL_PARTNERS: 'Third Party Commercial Partners',
};

export const PartnerTypeParams = {
  INDIVIDUAL: 'INDIVIDUAL',
  EDUCATION_AGENT: 'EDUCATION_AGENT',
  UNIVERSITY_INCLUDING_FEEDER: 'UNIVERSITY_INCLUDING_FEEDER',
  STUDENT_ASSOCIATION: 'STUDENT_ASSOCIATION',
  ONLINE: 'ONLINE',
  OTHER: 'OTHER',
  MARKETING_MEDIA_PARTNER: 'MARKETING_MEDIA_PARTNER',
  GLOBAL_EDUCATION_PARTNER: 'GLOBAL_EDUCATION_PARTNER',
  THIRD_PARTY_PARTNER_EASY_TRANSFER_USA: 'THIRD_PARTY_PARTNER_EASY_TRANSFER_USA',
  UNIVERSITY_STUDENT_AMBASSADOR: 'UNIVERSITY_STUDENT_AMBASSADOR',
  EDUCATION_PARTNER: 'EDUCATION_PARTNER',
  THIRD_PARTY_PARTNER_HOOLI_HOME: 'THIRD_PARTY_PARTNER_HOOLI_HOME',
  THIRD_PARTY_EDUCATION_RELATED_SERVICE_PROVIDER: 'THIRD_PARTY_EDUCATION_RELATED_SERVICE_PROVIDER',
  THIRD_PARTY_PARTNER_STUDAPART: 'THIRD_PARTY_PARTNER_STUDAPART',
  CHAT_GROUP: 'CHAT_GROUP',
  SOCIAL: 'SOCIAL',
  THIRD_PARTY_COMMERCIAL_PARTNERS: 'THIRD_PARTY_COMMERCIAL_PARTNERS',
};
